import { io } from "socket.io-client";
import Config from "./utils/Config";

let notificationSocket = null;

export const connectNotificationSocket = (token, companyId) => {

  disconnectNotificationSocket();

  notificationSocket = io(Config.BACKEND_URL, {
    path: Config.WS_PATH,
    auth: {
      authorization: token,
      companyId: companyId,
    },
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 10000,
  });

  
  notificationSocket.on('connect_error', (err) => {
    if (err.message?.includes('auth') || err.message?.includes('token') || err.message?.includes('jwt')) {
      console.warn('Notification socket auth failed, stopping reconnection:', err.message);
      notificationSocket.disconnect();
    }
  });

  return notificationSocket;
};

export const getNotificationSocket = () => {
  return notificationSocket;
};

export const disconnectNotificationSocket = () => {
  if (notificationSocket) {
    notificationSocket.removeAllListeners();
    notificationSocket.disconnect();
    notificationSocket = null;
  }
};
